
const options = {
  weekday: "long",
  year: "numeric",
  month: "long",
  day: "numeric"
};
export function toLocaleDate(date) {
  return new Date(date).toLocaleDateString(
    undefined,
    options
  );
}

export function addMonths(date, months) {
  var d = date.getDate();
  date.setMonth(date.getMonth() + +months);
  if (date.getDate() != d) {
    date.setDate(0);
  }
  return date;
}

export function fromSQLDate(date) {
  return new Date(Date.parse(date.replace(/-/g, '/')));
}

export let daysOfWeek = [
  ['Dimanche', 'Dim'],
  ['Lundi', 'Lun'],
  ['Mardi', 'Mar'],
  ['Mercredi', 'Mer'],
  ['Jeudi', 'Jeu'],
  ['Vendredi', 'Ven'],
  ['Samedi', 'Sam']
];

export let monthsOfYear = [
  ['Janvier', 'Jan'],
  ['Février', 'Fev'],
  ['Mars', 'Mar'],
  ['Avril', 'Avr'],
  ['Mai', 'Mai'],
  ['Juin', 'Jun'],
  ['Juillet', 'Jul'],
  ['Août', 'Aoû'],
  ['Septembre', 'Sep'],
  ['Octobre', 'Oct'],
  ['Novembre', 'Nov'],
  ['Décembre', 'Dec']
];
